import { useAtom } from 'jotai';
import React from 'react';
import { imgUrlAtom } from '../../atoms';
import { BsXLg } from "react-icons/bs";
import './ImgDialog.css';

const ImgDialog: React.FC = () => {
    const [imgUrl, setImgUrl] = useAtom(imgUrlAtom);
    if(!imgUrl) { return <></>; }
    return (
        <div className='image-dialog-overlay'>
            <div className="image-dialog">
                <div className='image-dialog-inner'>
                    <button onClick={() => setImgUrl(undefined)}>
                        <BsXLg className='closeBtn' />
                    </button>
                    <img src={imgUrl} width="500" alt="拡大画像" />
                </div>
            </div>
        </div>
    );
};

export default ImgDialog;